import { c as _c } from "react/compiler-runtime";
import { BlacksmithLogomarkAnimationSVG } from "./BlacksmithLogoSVG";

/** Shared by the Suspense fallback and redirect stubs so the anvil stays up until the destination commits. */
export function MainPaneLoader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div data-slot="sidebar-main-loading" className="flex h-full items-center justify-center"><div className="w-32 h-32"><BlacksmithLogomarkAnimationSVG /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}